import React, { useState } from 'react';

export default function TagInput({ tags, onChange, placeholder }) {
    const [inputValue, setInputValue] = useState('');

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addTag();
        } else if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
            removeTag(tags.length - 1);
        }
    };

    const addTag = () => {
        const newTag = inputValue.trim();
        if (newTag && !tags.includes(newTag)) {
            onChange([...tags, newTag]);
        }
        setInputValue('');
    };

    const removeTag = (index) => {
        onChange(tags.filter((_, i) => i !== index));
    };

    return (
        <div className="tag-input-container">
            <div className="tags-wrapper">
                {tags.map((tag, index) => (
                    <span key={index} className="tag">
                        {tag}
                        <button type="button" className="tag-remove" onClick={() => removeTag(index)}>
                            ×
                        </button>
                    </span>
                ))}
                <input
                    type="text"
                    className="tag-input"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={addTag}
                    placeholder={tags.length === 0 ? placeholder : ''}
                />
            </div>
        </div>
    );
}
